module.exports = __webpack_public_path__ + "img/Weapon_163.c17f4803.png";